import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SmartModalModule } from '../smart-modal/smart-modal.module';
import { ShareJobModalComponent } from './share-job-modal.component';
import { SocialShareModule } from '../social-share/social-share.module';

@NgModule({
  declarations: [ShareJobModalComponent],
  imports: [
    CommonModule,    
    FormsModule,
    RouterModule,
    SocialShareModule,
    SmartModalModule
  ],
  exports : [
    ShareJobModalComponent
  ]
})
export class ShareJobModalModule { }
